import { Box } from "@mui/material";
import React from "react";

const ConfirmError: React.FC = () => {

  return <Box className="login_error center">
    <h5 className="mb32 title h-error">
        メール認証エラー
    </h5>
    
    <h6 className="p-error">
      ※エラー画面の内容※
    </h6>
    
  </Box>;
};

export default ConfirmError;
